module.exports = __webpack_public_path__ + "static/media/Group 1310.0df429bf.svg";